import React from 'react'
import CorporateTaskList from '../../features/corporateMemberTaskList/CorporateTaskList'

const CorporateMemberTaskList = () => {
    return (
        <CorporateTaskList />
    )
}
export default CorporateMemberTaskList